import copy from 'copy-to-clipboard';
import {mc} from '@/core';
import lang from './OverviewPage.lang';

export function maskWalletAddress(address: string) {
  const strLength = address?.length;
  if (strLength > 10) {
    return `${address.substring(0, 6)}...${address.substring(strLength - 4)}`;
  }
  return address;
}

export function execCopyAction(LG: any) {
  return function execCopy(data: string) {
    if (copy(data)) {
      mc.send('toast', 'info', {message: LG(lang.Copied)});
      return;
    }
    mc.send('toast', 'error', {message: LG(lang.Failed)});
  };
}
